module.exports = __webpack_public_path__ + "static/1-Common-Terrace-01-0330dd6f5406585258fd8ba19d296c47.webp";